import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
} from "@/components/ui/navigation-menu";
import { Button } from "@/components/landing/button";
import { Link, Arrow } from "@/components/landing/link";
import { prepareQuizStart } from "../../analytics";
import { cn } from "@/lib/utils";

const navItems: { label: string; href: string }[] = [
  { label: "FAQ", href: "/#faq" },
  { label: "Sources", href: "/medication-sources" },
  { label: "Support", href: "/support" },
];

function Wordmark() {
  return (
    <Link href="/" className="flex items-center gap-2 text-xl font-semibold tracking-tight">
      <img
        src="/brand/vessa-icon.png"
        alt=""
        aria-hidden="true"
        width="28"
        height="28"
        className="size-7 rounded-[6px]"
      />
      Vessa
    </Link>
  );
}

function DesktopNav({ className }: { className?: string }) {
  return (
    <nav className={cn("mx-auto flex w-full max-w-7xl items-center justify-between gap-4", className)}>
      <Wordmark />
      <NavigationMenu>
        <NavigationMenuList className="gap-8">
          {navItems.map((item) => (
            <NavigationMenuItem key={item.href}>
              <NavigationMenuLink asChild>
                <Link href={item.href}>{item.label}</Link>
              </NavigationMenuLink>
            </NavigationMenuItem>
          ))}
        </NavigationMenuList>
      </NavigationMenu>
      <Button asChild>
        <Link href="/quiz" onClick={() => prepareQuizStart({ placement: "navigation" })}>
          Build my journal <Arrow />
        </Link>
      </Button>
    </nav>
  );
}

function MobileNav({ className }: { className?: string }) {
  return (
    <nav className={cn("flex w-full max-w-7xl items-center justify-center gap-4", className)}>
      <Wordmark />
    </nav>
  );
}

export function Nav() {
  return (
    <>
      <MobileNav className="flex md:hidden" />
      <DesktopNav className="hidden md:flex" />
    </>
  );
}
